// @flow
export {
  default,
} from 'web-ssr/app/app-directory/components/AppZapTemplates/Container';
